import React from 'react'
import { Column } from '@antv/g2plot'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'

const HistogramFq = React.forwardRef((props: any, ref) => {
  const his = React.useRef<HTMLElement | string>('')
  const plot = React.useRef<Column>()
  const [selectedCategory, setSelectedCategory] = React.useState(null)

  React.useEffect(() => {
    //

    // eslint-disable-next-line react-hooks/exhaustive-deps
    plot.current = new Column(his.current, {
      ...props,
      color: (datum, defaultColor) => {
        return '#32B0C9'
      }
    })
  }, [])

  React.useEffect(() => {
    plot.current?.render()

    plot.current?.on('element:click', (event: any) => {
      const { data, x, y } = event

      if (data && data.data && data.data.name) {
        //) // 更新图表状态

        const status = plot.current?.getStates()

        if (status && status.some((i) => i.state === 'selected')) {
          setSelectedCategory(data.data.name)

          props.clickFn && props.clickFn(data)
        } else {
          props.clickFn && props.clickFn()

          setSelectedCategory(null)
        }
      }

      //
    })
  }, [])

  React.useImperativeHandle(ref, () => {
    return {
      plot
    }
  })

  return <Box ref={his} height={'220px'}></Box>
})
export default HistogramFq
